<form [formGroup]="notificationSettingForm">
  <div class="d-flex">
    @if (title()) {
      <h5 class="mt-auto small-caps">{{ title() }}</h5>
    }
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0"
              (click)="toggleEditing()">
        @if (!editing) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>
  <table class="table table-sm table-list">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <!-- BundleIdentifier -->
      <tr>
        <th title="Bundle identifier of app to which to apply these notification settings."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="bundleIdentifier"
                 class="col-form-label">Bundle Identifier</label>
        </th>
        <td>
          @if (!editing) {
            <label for="bundleIdentifier"
                   class="col-form-label">{{ notificationSetting()?.bundleIdentifier }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="bundleIdentifier"
                   formControlName="bundleIdentifier" />
          }
        </td>
      </tr>

      <!-- NotificationsEnabled -->
      <tr>
        <th title="Whether notifications are allowed for this app. Default is true."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="notificationsEnabled"
                 class="col-form-label"
                 i18n>Notifications Enabled</label>
        </th>
        <td>
          @if (!editing) {
            <label for="notificationsEnabled"
                   class="col-form-label">{{
            notificationSetting()?.notificationsEnabled
            }}</label>
          } @else {
            <div class="form-check">
              <input id="notificationsEnabled"
                     formControlName="notificationsEnabled"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <!-- ShowInNotificationCenter -->
      <tr>
        <th title="Whether notifications can be shown in notification center. Default is true."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="showInNotificationCenter"
                 class="col-form-label"
                 i18n>Show In Notification Center</label>
        </th>
        <td>
          @if (!editing) {
            <label for="showInNotificationCenter"
                   class="col-form-label">{{
            notificationSetting()?.showInNotificationCenter
            }}</label>
          } @else {
            <div class="form-check">
              <input id="showInNotificationCenter"
                     formControlName="showInNotificationCenter"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <!-- ShowInLockScreen -->
      <tr>
        <th title="Whether notifications can be shown in the lock screen. Default is true."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="showInLockScreen"
                 class="col-form-label"
                 i18n>Show In Lockscreen</label>
        </th>
        <td>
          @if (!editing) {
            <label for="showInLockScreen"
                   class="col-form-label">{{ notificationSetting()?.showInLockScreen }}</label>
          } @else {
            <div class="form-check">
              <input id="showInLockScreen"
                     formControlName="showInLockScreen"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <!-- AlertType-->
      <tr>
        <th title="The type of alert for notifications for this app:"
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="alertType"
                 class="col-form-label"
                 i18n>Alert Type</label>
        </th>
        <td>
          @if (!editing) {
            <label for="alertType"
                   class="col-form-label">
              @switch (notificationSetting()?.alertType) {
                @case (0) {
                  <span i18n>None</span>
                }
                @case (1 || undefined || null) {
                  <span i18n>Banner</span>
                }
                @case (2) {
                  <span i18n>Model Alert</span>
                }
              }
            </label>
          } @else {
            <select id="alertType"
                    formControlName="alertType"
                    class="form-select">
              <option value="0"
                      i18n>None</option>
              <option value="1"
                      i18n>Banner</option>
              <option value="2"
                      i18n>Model Alert</option>
            </select>
          }
        </td>
      </tr>

      <!-- BadgesEnabled -->
      <tr>
        <th title="Whether badges are allowed for this app. Default is true."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="badgesEnabled"
                 class="col-form-label"
                 i18n>Badges Enabled</label>
        </th>
        <td>
          @if (!editing) {
            <label for="badgesEnabled"
                   class="col-form-label">{{ notificationSetting()?.badgesEnabled }}</label>
          } @else {
            <div class="form-check">
              <input id="badgesEnabled"
                     formControlName="badgesEnabled"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <!-- SoundsEnabled -->
      <tr>
        <th title="Whether sounds are allowed for this app. Default is true."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="soundsEnabled"
                 class="col-form-label"
                 i18n>Sounds Enabled</label>
        </th>
        <td>
          @if (!editing) {
            <label for="soundsEnabled"
                   class="col-form-label">{{ notificationSetting()?.soundsEnabled }}</label>
          } @else {
            <div class="form-check">
              <input id="soundsEnabled"
                     formControlName="soundsEnabled"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <!-- ShowInCarPlay -->
      <tr>
        <th title="Whether notifications can be shown in CarPlay. Default is true. Availability: Available in iOS 12 and later."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="showInCarPlay"
                 class="col-form-label"
                 i18n>Show In CarPlay</label>
        </th>
        <td>
          @if (!editing) {
            <label for="showInCarPlay"
                   class="col-form-label">{{ notificationSetting()?.showInCarPlay }}</label>
          } @else {
            <div class="form-check">
              <input id="showInCarPlay"
                     formControlName="showInCarPlay"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <!-- CriticalAlertEnabled -->
      <tr>
        <th title="Whether an app can mark a notification as a critical notification that will ignore Do Not Disturb and ringer settings. Default is false. Availability: Available in iOS 12 and later."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="criticalAlertEnabled"
                 class="col-form-label"
                 i18n>Critical Alert Enabled</label>
        </th>
        <td>
          @if (!editing) {
            <label for="criticalAlertEnabled"
                   class="col-form-label">{{
            notificationSetting()?.criticalAlertEnabled
            }}</label>
          } @else {
            <div class="form-check">
              <input id="criticalAlertEnabled"
                     formControlName="criticalAlertEnabled"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>
    </tbody>
  </table>
</form>